/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ second: NonNullable<unknown> }} Endpoint_Play_AnsweredInputs */

const en_endpoint_play_answered = /** @type {(inputs: Endpoint_Play_AnsweredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Example call: ${i?.second} answered, in the same call.`)
};

const zh_hans1_endpoint_play_answered = /** @type {(inputs: Endpoint_Play_AnsweredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`示例调用：${i?.second} 在同一次调用中返回了结果。`)
};

const pt_br2_endpoint_play_answered = /** @type {(inputs: Endpoint_Play_AnsweredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chamada de exemplo: ${i?.second} respondeu, na mesma chamada.`)
};

const es_endpoint_play_answered = /** @type {(inputs: Endpoint_Play_AnsweredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Llamada de ejemplo: ${i?.second} respondió, en la misma llamada.`)
};

const fr_endpoint_play_answered = /** @type {(inputs: Endpoint_Play_AnsweredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exemple d’appel : ${i?.second} a répondu, dans le même appel.`)
};

const de_endpoint_play_answered = /** @type {(inputs: Endpoint_Play_AnsweredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beispielaufruf: ${i?.second} hat geantwortet, im selben Aufruf.`)
};

const ru_endpoint_play_answered = /** @type {(inputs: Endpoint_Play_AnsweredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пример вызова: ответил ${i?.second}, в том же вызове.`)
};

const it_endpoint_play_answered = /** @type {(inputs: Endpoint_Play_AnsweredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chiamata di esempio: ha risposto ${i?.second}, nella stessa chiamata.`)
};

/**
* | output |
* | --- |
* | "Example call: {second} answered, in the same call." |
*
* @param {Endpoint_Play_AnsweredInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_play_answered = /** @type {((inputs: Endpoint_Play_AnsweredInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Play_AnsweredInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_play_answered(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_play_answered(inputs)
	if (locale === "es") return es_endpoint_play_answered(inputs)
	if (locale === "fr") return fr_endpoint_play_answered(inputs)
	if (locale === "de") return de_endpoint_play_answered(inputs)
	if (locale === "ru") return ru_endpoint_play_answered(inputs)
	if (locale === "it") return it_endpoint_play_answered(inputs)
	return en_endpoint_play_answered(inputs)
});